import React from 'react';
import { DefaultButton, TextField, PrimaryButton, ITextFieldProps, CommandBar, IContextualMenuItem, Panel, PanelType, Fabric } from "@fluentui/react";
import { ICheckAnonymousRequestProps } from './check-anonymous-request.props';
import { ICheckAnonymousRequestState } from './check-anonymous-request.state';
import { PqrWebService } from '../../services/services';
import { defaultIRadicadoEntradaExtended, IRadicadoEntradaExtended } from '../../classes/radicado-entrada-extended';
import { validator, validateObject, EstadoRadicado } from '../../ioip/sdk/base';

export class CheckAnonymousRequestComponent extends React.Component<ICheckAnonymousRequestProps, ICheckAnonymousRequestState> {

    private _pqrWebService: PqrWebService = new PqrWebService();

    constructor(props: any) {
        super(props);
        this.state = {
            showRequest: false,
            NumeroRadicado: '',
            CodigoConsulta: '',
            solicitud: defaultIRadicadoEntradaExtended(),
            errors: {}
        }
    }

    render(): JSX.Element {
        return (
            <div className='ms-Grid'>
                <div className='ms-Grid-row'>
                    <div className="ms-Grid-col ms-u-sm12">
                        <h1 className='ms-font-xl ms-fontWeight-semibold'> Consultar solicitud anónima</h1>
                    </div>
                </div>
                <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-u-sm6'>
                        <TextField
                            placeholder='Número de radicado'
                            label='Número de radicado'
                            maxLength={50}
                            required={true}
                            onChange={(_, value) => this.setState({ NumeroRadicado: value })}
                            errorMessage={this.state.errors[ 'NumeroRadicado' ]}
                            value={this.state.NumeroRadicado} />
                    </div>
                    <div className='ms-Grid-col ms-u-sm6'>
                        <TextField
                            placeholder='Código de consulta'
                            label='Código de consulta'
                            maxLength={50}
                            required={true}
                            onChange={(_, value) => this.setState({ CodigoConsulta: value })}
                            errorMessage={this.state.errors[ 'CodigoConsulta' ]}
                            value={this.state.CodigoConsulta} />
                    </div>
                </div>
                <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'right', marginBottom: '15px' }}>
                        <PrimaryButton
                            text='Buscar'
                            onClick={this._search.bind(this)}
                        />
                        <span>&nbsp;&nbsp;</span>
                        {!this.state.showRequest &&
                            <DefaultButton
                                text='Volver'
                                href='#/home'
                            />
                        }
                    </div>
                </div>
                {this.state.showRequest &&
                    <div className='ms-Grid'>
                        <div className='ms-Grid-row'>
                            <div className='ms-Grid-col ms-u-sm12'>
                                <CommandBar items={this._buildCommand()} className='command-bar-1' />
                            </div>
                        </div>
                        <div className='ms-Grid-row'>
                            <div className='ms-Grid-col ms-u-sm6'>
                                <TextField
                                    placeholder='Trámite'
                                    label='Trámite'
                                    value={this.state.solicitud.Tramite}
                                    readOnly={true} />
                            </div>
                            {this.state.solicitud.IdRadicadoSalida !== null ?
                                <div className='ms-Grid-col ms-u-sm6'>
                                    <TextField
                                        placeholder='Estado'
                                        label='Estado respuesta'
                                        value={this.state.solicitud.EstadoRadicadoSalida}
                                        readOnly={true} />
                                </div>
                                :
                                <div className='ms-Grid-col ms-u-sm6'>
                                    <TextField
                                        placeholder='Estado'
                                        label='Estado solicitud'
                                        value={this.state.solicitud.Estado}
                                        readOnly={true} />
                                </div>
                            }
                        </div>
                        <div className='ms-Grid-row'>
                            <div className='ms-Grid-col ms-u-sm6'>
                                <TextField
                                    placeholder='Clasificación'
                                    label='Clasificación'
                                    value={this.state.solicitud.ClasificacionPQRS}
                                    readOnly={true} />
                            </div>
                            <div className='ms-Grid-col ms-u-sm6'>
                                <TextField
                                    placeholder='Fecha de creación'
                                    label='Fecha de creación'
                                    value={this.state.solicitud.FechaCreacionString}
                                    readOnly={true} />
                            </div>
                        </div>
                        <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'right' }}>
                            <DefaultButton
                                text='Volver al inicio'
                                href='#/home'
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }

    private _updateErrors(errors: { [ key: string ]: string }): void {
        this.setState({ errors });
    }

    private setShowRequest(value: boolean) {
        this.setState({
            ...this.state,
            showRequest: value
        })
    }

    private _buildCommand(): IContextualMenuItem[] {
        const commandBar: IContextualMenuItem[] = [];
        commandBar.push({
            key: 'Descargar solicitud',
            name: 'Descargar solicitud',
            iconProps: { iconName: 'Download' },
            onClick: () => {
                this._pqrWebService.downloadRadicadoEntradaAsAnonymous(this.state.solicitud.IdRadicadoEntrada);
            }
        });
        commandBar.push({
            key: 'Descargar anexos',
            name: 'Descargar anexos',
            iconProps: { iconName: 'Download' },
            onClick: () => {
                this._pqrWebService.downloadAnexosRadicadoEntradaAsAnonymous(this.state.solicitud.IdRadicadoEntrada);
            }
        });
        if (this.state.solicitud.IdRadicadoSalida != null && (this.state.solicitud.IdEstadoActual === EstadoRadicado.Respondido ||
            this.state.solicitud.IdEstadoActual === EstadoRadicado.Archivado)) {
            commandBar.push(
                {
                    key: 'Descargar respuesta',
                    name: 'Descargar respuesta',
                    iconProps: { iconName: 'Download' },
                    onClick: () => {
                        this._pqrWebService.downloadRadicadoSalidaAsAnonymous(this.state.solicitud.IdRadicadoSalida);
                    }
                }
            );
            if (this._verifyAttachmentsRadicadoSalida(this.state.solicitud.IdRadicadoSalida)) {
                commandBar.push(
                    {
                        key: 'Descargar anexos respuesta',
                        name: 'Descargar anexos respuesta',
                        iconProps: { iconName: 'Download' },
                        onClick: () => {
                            this._pqrWebService.downloadAttactmentsRadicadoSalidaAsAnonymous(this.state.solicitud.IdRadicadoSalida);
                        }
                    });
            }
        }
        return commandBar;
    }
    private async _verifyAttachmentsRadicadoSalida(idRadicadoSalida: number): Promise<boolean> {
        const result: boolean = await this._pqrWebService.verifyAttachmentsRadicadoSalidaAsync(idRadicadoSalida);
        return result;
    }

    private async _search() {
        this.setShowRequest(false);
        const _validations: { [ key: string ]: any[] } = {
            NumeroRadicado: [ validator.invalid(0, 'Campo requerido') ],
            CodigoConsulta: [ validator.required(true) ]
        };
        if (validateObject(this.state, _validations, this._updateErrors.bind(this))) {
            try {
                const result: IRadicadoEntradaExtended = await this._pqrWebService.getMyRequestsByNumberAndCodeAsAnonymousAsync(this.state.NumeroRadicado, this.state.CodigoConsulta);
                this.setState({
                    solicitud: result
                })
                this.setShowRequest(true);
            } catch (ex) {
                this.setState({
                    errors: {
                        'error': ex as any
                    }
                });
            }
        }
    }
}